import type { ConfigureIntegrationResult } from '@cli-types/next-adapter/runtime.js'
import { appendEnvVars } from '@cli-utils/files.js'
import { collectVercelBlobConfig } from './collect-vercel-blob-config.js'

export async function promptVercelBlobConfig(cwd: string): Promise<ConfigureIntegrationResult> {
  const collected = await collectVercelBlobConfig(cwd)
  const envResult = appendEnvVars(cwd, collected.sections, collected.overwriteKeys)

  return {
    configured: true,
    addedEnvKeys: envResult.added,
    updatedEnvKeys: envResult.updated
  }
}
